export var en = {
  blanks: 'Blanks',
  filter: 'Filters',
  filterSelected: 'Filter Selected',
  filtersSelected: 'Filters Selected',
  filterApplied: 'Filter Applied',
  filtersApplied: 'Filters Applied',
  clear: 'Clear',
  apply: 'Apply',
  seeAllFilters: 'See All Filters',
  EditFilters: 'Edit Filters',
  RestoreToDefaultOrder: 'Restore to default order',
  cancel: 'Cancel',
  save: 'Save',
  delete: 'Delete',
  DragFilterPositionExplain: 'Drag and drop rows to change the order in which the filters are displayed (left to right, top to bottom)',
  Order: 'Order',
  Filters: 'Filters',
  allFilters: 'All Filters',
  clearAllFilters: 'Clear All Filters',
  noResultsAvailable: 'No Results available.',
  selectAll: 'Select All',
  // Program
  SoftwareOpen: 'Measurement Software Opened',
  SoftwareClose: 'Measurement Software Closed',
  SoftwareCreating: 'Program Entered Edit Mode',
  SoftwareError: 'Program Execution Error',
  SoftwareExecuting: 'System Executing',
  SoftwareIdle: 'System Idle',
  SoftwareWaiting: 'Operator Input Requested',
  PartProgramCanceled: 'Program Canceled',
  PartProgramClosed: 'Program Closed',
  PartProgramCompleted: 'Program Completed',
  PartProgramContinued: 'Program Resumed',
  PartProgramOpened: 'Program Opened',
  PartProgramStarted: 'Program Started',
  PartProgramStopped: 'Program Stopped',
  PartProgramPaused: 'Program Paused',
  ReportPdfPrinted: 'Program Generated',
  FeatureFailed: 'Dimension Failed',
  FeaturePassed: 'Dimension Passed',
  PartOutOfTolerance: 'Part Out Of Tolerance',
  PartReportUploaded: 'Part Report Uploaded',
  NewPartReportAvailable: 'Part Report Uploaded',
  // Computer
  ComputerResumed: 'Computer Resumed',
  ComputerSuspended: 'Computer Suspended',
  // GeoFence and GPSTag
  LeftGeoFence: 'Left GeoFence',
  EnteredGeoFence: 'Entered GeoFence',
  GPSTagBatteryLow: 'GPS Tag Battery Low',
  GPSTagBatteryDepleted: 'GPS Tag Battery Depleted',
  GPSStorageTempCritical: 'GPS Storage Temp Critical',
  GPSStorageTempWarning: 'GPS Storage Temp Warning',
  StorageTemperature: 'Storage Temperature',
  // Arm
  ShockAlert: 'Shock Alert',
  ShockDetected: 'Shock Detected',
  FanAlert: 'Fan Alert',
  FanSpeedOutOfRange: 'Fan Speed Out Of Range',
  FanSpeedOutOfRangeAlert: 'Fan Speed Out Of Range Alert',
  TemperatureAlert: 'Temperature Alert',
  ScanningProfileChanged: 'Scanning Profile Changed',
  ScannerLaserTimeAlert: 'Scanner Laser Time Alert',
  ScannerEnabled: 'Scanner Enabled',
  ProbeHit: 'Probe Hit',
  LaserScannerTimeONAlert: 'Laser Scanner Time ON Alert',
  Rs6TemperatureAlert: 'Rs6 Temperature Alert',
  Rs5TemperatureAlert: 'Rs5 Temperature Alert',
  WristDisplayAlert: 'Wrist Display Alert',
  HapticAlert: 'Haptic Alert',
  ConnectionCountAlert: 'Connection Count Alert',
  ButtonPressedAlert: 'Button Pressed Alert',
  BatteriesHealthAlert: 'Batteries Health Alert',
  ButtonLifetimeAlert: 'Button Lifetime Alert',
  BatteryLifetimeAlert: 'Battery Lifetime Alert',
  BatteryCharging: 'Battery Charging',
  ProjectorLifetimeAlert: 'Projector Lifetime Alert',
  EncoderStatusBitAlert: 'Encoder Status Bit Alert',
  EncoderTemperatureAlert: 'Encoder Temperature Alert',
  GasShockLifetimeAlert: 'Gas Shock Lifetime Alert',
  NewConnection: 'New Connection',
  RsSquaredAlert: 'Rs Squared Alert',
  EncoderAlert: 'Encoder Alert',
  GasShockAlert: 'Gas Shock Alert',
  // Machine Tool
  EstopPressed: 'E-stop Pressed',
  EstopReleased: 'E-stop Released',
  // Sensor:
  Crash: 'Crash',
  Vibration: 'Vibration',
  AirPressure: 'AirPressure',
  Humidity: 'Humidity',
  Illuminance: 'Illuminance',
  Temperature: 'Temperature',
  // Others
  asset: 'Asset',
  controller: 'Controller',
  unknown: 'Unknown',
  cmmSystem: 'CMM System',
  Routine: 'Program',
  Feature: 'Feature',
  // Status
  warning: 'Warning',
  info: 'Info',
  critical: 'Critical',
  disconnected: 'Disconnected',
  connected: 'Connected',
  settings: 'Settings',
  // avatar
  SFxAvatarLimitSizeErrorMsg: 'The size of the uploaded image does not match the requirements.',
  SFxAvatarSuggestImageSizeInfo: 'Suggested image size at least 500px x 500px.',
  SFxAvatarChoseImageInfo: 'Choose an Image',
  SFxAvatarCancel: 'Cancel',
  SFxAvatarSavaPhoto: 'Save Photo',
  SFxAvatarDelete: 'Delete',
  SFxAvatarDeleteAvatar: 'Delete avatar',
  SFxAvatarDeleteAvatarInfo: 'Do you want to delete the avatar?',
  SFxAvatarDeleteAvatarErrorMsg: 'Delete avatar failed',
  SFxAvatarOptional: 'Optional',
  SFxAvatarUploadAvatarErrorMsg: 'Upload avatar failed',
  // footer
  SFxFooterFooterMsg: 'Hexagon AB and/or its subsidiaries.',
  // TableView
  SFxTableViewSortZ_A: 'Sort Z-A',
  SFxTableViewSortA_Z: 'Sort A-Z',
  SFxTableNoData: 'No results available',
  // userProfile
  SFxUserProfileLanguageAndRegion: 'Language & Region',
  SFxUserProfileProfileInformation: 'Profile Information',
  SFxUserProfileAddresses: 'Addresses',
  SFxUserProfileAddAddress: 'Add Address',
  SFxUserProfileAddressName: 'Address Name',
  SFxUserProfileUserImage: 'User Image',
  SFxUserProfileGetStarted: 'Get Started',
  SFxUserProfileCompleteYourProfile: 'Complete Your Profile',
  SFxUserProfileConfirmContent: "Do you want to save the changes you made to your profile? If you don't save, the changes will be lost.",
  SFxUserProfileAdd: 'Add',
  SFxUserProfileUpdate: 'Update',
  SFxUserProfileConfirmSave: 'Save',
  SFxUserProfileCancel: 'Cancel',
  SFxUserProfileReset: 'Reset',
  SFxUserProfileBack: 'Back',
  SFxUserProfileFinish: 'Finish',
  SFxUserProfileNext: 'Next',
  SFxUserProfilePhoneValidMsg: ' Please only use +, -, ( ),. , and spaces to divide phone numbers in this section.',
  SFxUserProfileCompany: 'Company',
  SFxUserProfileEmail: 'Email',
  SFxUserProfileFirstName: 'First Name',
  SFxUserProfileLastName: 'Last Name',
  SFxUserProfileLanguage: 'Language',
  SFxUserProfileTimeZone: 'Time Zone',
  SFxUserProfilePhoneNumbers: 'Phone Numbers',
  SFxUserProfilePhoneNumber: 'Phone Number',
  SFxUserProfileAddPhoneNumbers: 'Add Phone Number',
  SFxUserProfilePhoneType: 'Phone Type',
  SFxUserProfileCustom: 'Custom',
  SFxUserProfileMobilePhone: 'Mobile Phone',
  SFxUserProfileOfficePhone: 'Office Phone',
  SFxUserProfileBusinessPhone: 'Business Phone',
  SFxUserProfileHomePhone: 'Home Phone',
  SFxUserProfileFax: 'Fax',
  SFxUserProfileCustomName: 'Custom Name',
  SFxUserProfilePhoneCountryCode: 'Phone Country Code',
  SFxUserProfileExtension: 'Extension',
  SFxUserProfileCountry: 'Country',
  SFxUserProfileStateOrProvince: 'State / Province',
  SFxUserProfileCity: 'City',
  SFxUserProfileAddExtension: 'Add Extension',
  SFxUserProfileAddress: 'Address',
  SFxUserProfileAddressLine2: 'Address Line 2',
  SFxUserProfileZipOrPostCode: 'Zip code / Postal Code',
  SFxUserProfileWelcomeContent: 'Welcome to your new SFx {0} account!',
  SFxUserProfileStartContent: ' Start completing your profile by choosing your Language & Region.',
  SFxUserProfileStartExploring: 'Now you can start exploring {0}. Welcome and enjoy!',
  SFxUserProfileForewordContent: 'Please take a minute to complete your user profile before taking a solution tour or getting stated. This information can be edited later on if you would like to add or change anything.',
  SFxUserProfileCompleteContent: 'You have now completed your user profile. This information can be accessed in your user dropdown and edited later on if you would like to add or change anything.',
  SFxUserProfileSetMainCompanyAddress: 'Set main company facility address as user contact address?',
  // UserPreferences
  SFxUserPreferencesResetLayoutConfirm: 'Are you sure you want to restore all settings to their default values?',
  SFxUserPreferencesResetLayoutTitle: 'Reset Settings',
  SFxUserPreferencesResetLayoutOkButton: 'Yes, Reset',
  SFxUserPreferencesResetLayoutCancelButton: 'Cancel',
  SFxUserPreferencesMenuProfileText: 'My Profile',
  SFxUserPreferencesMenuSecurityText: 'Security',
  SFxUserPreferencesMenuThemeText: 'Themes',
  SFxUserPreferencesTitle: 'User Preferences',
  SFxUserPreferencesEmailLabel: 'Email / Username',
  SFxUserPreferencesCountryLabel: 'Country',
  SFxUserPreferencesLanguageLabel: 'Language',
  SFxUserPreferencesTimeZoneLabel: 'Time Zone',
  SFxUserPreferencesPhoneNumTitle: 'Phone Numbers',
  SFxUserPreferencesAddressesTitle: 'Addresses',
  SFxUserPreferencesBasicInfo: 'Basic Information',
  SFxUserPreferencesLanguageRegion: 'Language & Region',
  SFxUserPreferencesContactAddress: 'Contact & Addresses',
  SFxUserPreferencesSaveButton: 'Save Changes',
  SFxUserPreferencesPhoneEmailLabel: 'Phone Type',
  SFxUserPreferencesPhoneCustomNameLabel: 'Custom Name',
  SFxUserPreferencesPhoneCountryCodeLabel: 'Phone Country Code',
  SFxUserPreferencesPhoneNumberLabel: 'Phone Number',
  SFxUserPreferencesPhoneAddExtText: 'Add Extension',
  SFxUserPreferencesPhoneExtension: 'Extension',
  SFxUserPreferencesAddPhoneNumberText: 'Add Phone Number',
  SFxUserPreferencesAddressNameLabel: 'Address Name',
  SFxUserPreferencesAddressLabel: 'Address',
  SFxUserPreferencesAddressLine2Label: 'Address Line2',
  SFxUserPreferencesAddressCountryLabel: 'Country',
  SFxUserPreferencesAddressStateLabel: 'State / Province',
  SFxUserPreferencesAddressCityLabel: 'City',
  SFxUserPreferencesAddressZipCodeLabel: 'Zip code / Postal Code',
  SFxUserPreferencesAddAddressText: 'Add Address',
  SFxUserPreferencesPasswordTitle: 'Password',
  SFxUserPreferencesPasswordSubtitle: 'Password Reset',
  SFxUserPreferencesSecurityQuestionTitle: 'Security Question',
  SFxUserPreferencesSecurityQuestionSubtitle: 'Change Your Security Question',
  SFxUserPreferencesRestPwNoMatch: 'The passwords you entered do not match. Please try again.',
  SFxUserPreferencesRestPwIncorrect: 'Please make sure your old password is correct.',
  SFxUserPreferencesRestPwNotNew: 'The new password you entered is the same as your old password. Please enter a different password.',
  SFxUserPreferencesRestPwError: "New Password does not meet requirements \n\n    \xB7 8-32 characters in length \n\n    \xB7 At least one uppercase letter \n\n    \xB7 At least one lowercase letter \n\n    \xB7 At least one number \n\n    \xB7 At least one special character \n\n  ",
  SFxUserPreferencesCurrentPwLabel: 'Current Password',
  SFxUserPreferencesNewPwLabel: 'New Password',
  SFxUserPreferencesVerifyPwLabel: 'Verify Password',
  SFxUserPreferencesChangePw: 'Change Password',
  SFxUserPreferencesForgotPw: 'Forgot Your Password?',
  SFxUserPreferencesCurrentQsLabel: 'Current Security Question',
  SFxUserPreferencesCurrentAnswerLabel: 'Current Answer',
  SFxUserPreferencesNewAnswerLabel: 'New Answer',
  SFxUserPreferencesNewSqLabel: 'New Security Question',
  SFxUserPreferencesNewSqAnswerLabel: 'Answer',
  SFxUserPreferencesSetSqText: 'Set Security Question',
  SFxUserPreferencesNewSqFailed: 'Failed to new security Question.',
  SFxUserPreferencesCheckAnswerError: 'The answer to the current modified security question is incorrect.',
  SFxUserPreferencesChangeThemeButtonText: 'Save Changes',
  SFxUserPreferencesLightThemeLabel: 'Light Theme',
  SFxUserPreferencesDarkThemeLabel: 'Dark Theme',
  SFxUserPreferencesFirstNameLabel: 'First Name',
  SFxUserPreferencesLastNameLabel: 'Last Name',
  SFxUserPreferencesRestLayoutMenu: 'Reset Settings',
  SFxUserPreferencesTableSaveText: 'Save',
  SFxUserPreferencesTableCancelText: 'Cancel',
  SFxCustomPhone: 'Custom',
  SFxMobilePhone: 'Mobile Phone',
  SFxOfficePhone: 'Office Phone',
  SFxBusinessPhone: 'Business Phone',
  SFxHomePhone: 'Home Phone',
  SFxFaxPhone: 'Fax',
  SFxUserTimeZoneSelectCountryFirst: 'Select Country First',
  // Pagination
  SFxPage: 'Page',
  SFxOf: 'of',
  SFxResults: 'Results',
  SFxResult: 'Result',
  SFxResultsPerPage: 'Results per page',
  // Event Log
  SFxTotalEvents: 'Events Total',
  SFxEvents: 'Events',
  // Datepicker
  AM: 'AM',
  PM: 'PM',
  SFxFrom: 'From',
  SFxTo: 'To',
  SFxStartTime: 'Start Time',
  SFxEndTime: 'End Time',
  SFxDate: 'Date',
  SFxClear: 'Clear',
  SFx1D: '1D',
  SFx1W: '1W',
  SFx1M: '1M',
  SFxCUSTOM: 'CUSTOM',
  // SolutionBar
  SFxSolutionBarTitle: 'My Solutions',
  SFxDiscover: 'Discover',
  SFxHexagonStore: 'Hexagon e-Store',
  // Sort
  SFxSortSortBy: 'Sort by',
  SFxSortClear: 'Clear',
  SFxSortInOrder: 'in the following order',
  SFxSortFrom: 'from',
  SFxSortZtoA: 'Z to A',
  SFxSortAtoZ: 'A to Z',
  // ResponsiveLayout
  SFxResponsiveLayoutExpand: 'Expand',
  SFxResponsiveLayoutCollapse: 'Collapse',
  SFxResponsiveLayoutMaximize: 'Maximize',
  SFxResponsiveLayoutMinimize: 'Minimize',
  // AccountSettings
  SFxAccountSettingsBreadcrumbHome: 'Home',
  SFxAccountSettingsTitle: 'Account Settings',
  SFxAccountSettingsMenuUsers: 'Users',
  SFxAccountSettingsMenuSolutions: 'Solutions',
  SFxAccountSettingsMenuPlants: 'Plants',
  SFxAccountSettingsMenuSubscriptions: 'Subscriptions',
  SFxAccountSettingsUserSearchInput: 'Search Name',
  SFxAccountSettingsAddUserButtonText: 'Add New User',
  SFxAccountSettingsRequestUserButtonText: 'Request User',
  SFxAccountSettingsUserTableNameTitle: 'Name',
  SFxAccountSettingsUserTableLastAccessTitle: 'LastAccess',
  SFxAccountSettingsUserTableRoleTitle: 'Solutions & Roles',
  SFxAccountSettingsUserTableSFxRoleTitle: 'SFx Role',
  SFxAccountSettingsAddUserModalTitle: 'Add User',
  SFxAccountSettingsEditUserModalTitle: 'Edit',
  SFxAccountSettingsAddUserModalAddUser: 'Add User',
  SFxAccountSettingsUserDetailModalTitle: 'User Details',
  SFxAccountSettingsUserEmailLabel: 'Email',
  SFxAccountSettingsUserSFxRoleLabel: 'SFx Role',
  SFxAccountSettingsUserLastAccessLabel: 'Last Access',
  SFxAccountSettingsUserLastActiveLabel: 'Last Active',
  SFxAccountSettingsUserSolutionLabel: 'Solution',
  SFxAccountSettingsUserSolutionRoleLabel: 'Solution Role',
  SFxAccountSettingsUserSubscriptionLabel: 'Subscription',
  SFxAccountSettingsUserDetailTableSolutionTitle: 'Solution',
  SFxAccountSettingsUserDetailTableRolesTitle: 'Roles',
  SFxAccountSettingsUserDetailTableSubscriptionTitle: 'Subscription',
  SFxAccountSettingsEditUserButtonText: 'Edit User',
  SFxAccountSettingsFirstNameLabel: 'First Name',
  SFxAccountSettingsLastNameLabel: 'Last Name',
  SFxAccountSettingsSFxRoleLabel: 'SFx Role (optional)',
  SFxAccountSettingsAssignSolutionButtonText: 'Assign solution',
  SFxAccountSettingsCancelButtonText: 'Cancel',
  SFxAccountSettingsDeleteButtonText: 'Delete',
  SFxAccountSettingsBackButtonText: 'Back',
  SFxAccountSettingsDoneButtonText: 'Done',
  SFxAccountSettingsResetButtonText: 'Reset',
  SFxAccountSettingsSaveButtonText: 'Save',
  SFxAccountSettingsSubmitButtonText: 'Submit',
  SFxAccountSettingsModalAddUserSaveButtonText: 'Add',
  SFxAccountSettingsModalRequestUsertitleText: 'Request User',
  SFxAccountSettingsModalRequestUserSaveButtonTextText: 'Send Request',
  SFxAccountSettingsModalRequestUserContentTitleText: 'Request to add users to HxGN SFx Platform',
  SFxAccountSettingsModalRequestUserSubmitRequest: 'Invitation request for {0} new users successfully sent to your administrator!',
  SFxAccountSettingsModalRequestUserSubmitRequestFailed: 'Invitation request for {0} new users failed.',
  SFxAccountSettingsUserEmailValidateInviteUserMsg: 'There is already an invitation for this user.',
  SFxAccountSettingsAddPlantButtonText: 'Add Plant',
  SFxAccountSettingsDeletePlantSuccessMessage: 'You have successfully deleted this plant.',
  SFxAccountSettingsConfirmDeletePlantMessage: 'Are you sure you want to delete the {0} plant?',
  SFxAccountSettingsDeletePlantModalTitle: 'Delete Plant',
  SFxAccountSettingsPlantTableNameTitle: 'Plant Name',
  SFxAccountSettingsPlantTableAddressTitle: 'Plant Address',
  SFxAccountSettingsPlantNameLabel: 'Plant Name',
  SFxAccountSettingsPlantAddressLabel: 'Plant Address',
  SFxAccountSettingsPlantAddModalTitle: 'Add',
  SFxAccountSettingsPlantEditModalTitle: 'Edit',
  SFxAccountSettingsSubscriptionsSearchInput: 'Search Solutions',
  SFxAccountSettingsAddSubscriptionsButtonText: 'Redeem a Voucher',
  SFxAccountSettingsConfirmsubscriptionMessage: 'Have an SFx subscription voucher?',
  SFxAccountSettingsEnterVoucherCode: 'Enter your voucher code here:',
  SFxAccountSettingsVoucherModalTitle: 'Redeem a Voucher',
  SFxAccountSettingsVoucherModalTitlewhenSuccess: 'Submit voucher code',
  SFxAccountSettingsRedeemResultsSuccessTitle: 'Success!',
  SFxAccountSettingsRedeemResultsSuccessMsg: 'A new subscription has been created in your account!',
  SFxAccountSettingsRedeemResultsExpiredTitle: 'We’re Sorry',
  SFxAccountSettingsRedeemResultsExpiredMsg: 'This voucher code has expired. Please contact your Hexagon sales specialist.',
  SFxAccountSettingsRedeemResultsMissingTitle: 'We’re Sorry',
  SFxAccountSettingsRedeemResultsMissingMsg: "We can't find this voucher code. Please contact your Hexagon sales specialist.",
  SFxAccountSettingsRedeemResultsUsedTitle: 'We’re Sorry',
  SFxAccountSettingsRedeemResultsUsedMsg: 'This voucher code has already been used. Please contact your Hexagon sales specialist.',
  SFxAccountSettingsRedeemResultsUnknownTitle: 'We’re Sorry',
  SFxAccountSettingsRedeemResultsUnknownMsg: 'This voucher code is invalid. Please contact your Hexagon sales specialist.',
  SFxAccountSettingsSubscriptionsText: 'Subscriptions',
  SFxAccountSettingsSubscriptionText: 'Subscription',
  SFxAccountSettingsSubscriptionTableKeyTitle: 'Pro Subscription Key',
  SFxAccountSettingsSubscriptionTableIssueDateTitle: 'Issue Date',
  SFxAccountSettingsSubscriptionTableExpiryDateTitle: 'Expiry Date',
  SFxAccountSettingsSubscriptionTableDateSortTextAsc: 'Oldest to Newest',
  SFxAccountSettingsSubscriptionTableDateSortTextDesc: 'Newest to Oldest',
  SFxAccountSettingsSubscriptionTableTypeTitle: 'Type',
  SFxAccountSettingsSubscriptionTableObjectTitle: 'Object',
  SFxAccountSettingsAssignSubscriptionToUser: 'Assign Subscription to User',
  SFxAccountSettingsAssignSubscriptionToAsset: 'Assign Subscription to Asset',
  SFxAccountSettingsSubscribedUser: 'Subscribed User',
  SFxAccountSettingsSubscribedAsset: 'Subscribed Asset',
  SFxAccountSettingsUnassignSubscriptionsMessage: '* To unassign this subscription, select the blank row at the top of the list.',
  SFxAccountSettingsSolutionsSearchInput: 'Search Solutions',
  SFxAccountSettingsAssignUserButtonText: 'Assign user to solution',
  SFxAccountSettingsUserText: 'User',
  SFxAccountSettingsUsersText: 'Users',
  SFxAccountSettingsSolutionTableNameTitle: 'Name',
  SFxAccountSettingsSolutionTableRoleTitle: 'Role',
  SFxAccountSettingsSolutionTableLastAccessedTitle: 'Last Accessed',
  SFxAccountSettingsSolutionAssignUserModalTitle: 'Assign user to solution',
  SFxAccountSettingsSolutionModalSolutionLabel: 'Solution',
  SFxAccountSettingsSolutionModalEmailLabel: 'Email',
  SFxAccountSettingsSolutionModalSolutionRoleLabel: 'Solution Role',
  SFxAccountSettingsSolutionModalSubscriptionLabel: 'Subscription',
  SFxAccountSettingsSolutionModalAssignUserButtonText: 'Assign user',
  SFxAccountSettingsSubscriptionModalTitle: 'Assign Subscription',
  SFxAccountSettingsValidatePlantRequired: 'At least 1 character is required.',
  SFxAccountSettingsValidatePlantUnique: 'Duplicate name. Names must be unique.',
  SFxAccountSettingsValidatePlantLength: 'Cannot be more than 50 characters.',
  SFxAccountSettingsValidatePlantAddressLength: 'Cannot be more than 200 characters.',
  SFxAccountSettingsAddPlantsSuccessMsg: 'You have successfully added 1 plant.',
  SFxAccountSettingsEditPlantsSuccessMsg: 'You have successfully edited this plant.',
  SFxAccountSettingsValidatePasswordErrorMsg: 'Password is incorrect. Enter correctly to delete user.',
  SFxAccountSettingsDeleteUserSuccess: 'You have successfully deleted user {0}.',
  SFxAccountSettingsDeleteUserModalSaveButtonText: 'Yes, Delete',
  SFxAccountSettingsDeleteUserModalTitle: 'Delete User',
  SFxAccountSettingsDeleteUserConfirmMsg: ' Are you sure you want to permanently delete the user account of {0}?',
  SFxAccountSettingsDeleteUserConfirmPasswordMsg: 'This action can not be undone. Enter your password below to confirm.',
  SFxAccountSettingsUserPasswordPlaceHolder: 'Password',
  SFxAccountSettingsUserEmailValidateMsg: 'Email already in use',
  SFxAccountSettingsUserEmailRulesTip: "Create user with corporate domain email. \n  If your organization uses a generic mail server (@gmail, @yahoo, @aol, etc.), \n  this will require a longer manual validation with Hexagon support.",
  SFxAccountSettingsUnknownError: 'An unknown error',
  SFxAccountSettingsCreateUserSuccessMsg: "Invitations successfully sent {0} new users have been invited to join SFx.",
  SFxAccountSettingsCreateUserMaxMsg: "For organization that doesn't have subscriptions, the maximum number of users is {0}.",
  SFxAccountSettingsEditUserSuccessMsg: 'You have successfully edited user {0}',
  SFxAccountSettingsAssignUserSuccessMsg: "You have successfully assigned {0} users to {1}.",
  SFxAccountSettingsEditAssignUserSuccessMsg: "You have successfully edited user {0}.",
  SFxAccountSettingsSubscriptionOptionMsg: 'You have successfully {0} this PRO subscription key',
  SFxAccountSettingsSubscriptionTransferType: 'transfer',
  SFxAccountSettingsSubscriptionAssignedType: 'assigned',
  SFxAccountSettingsSubscriptionUnassignedType: 'unassigned',
  SFxAccountSettingsUserRequestTitle: 'User Request',
  SFxAccountSettingsUserRequestBanner: 'You have {0} awaiting approval.',
  SFxAccountSettingsSingleUserRequestNumber: '{0} New User Request',
  SFxAccountSettingsMutilUserRequestNumber: '{0} New User Requests',
  SFxAccountSettingsUserRequestRefresh: 'Refresh',
  SFxAccountSettingsUserRequestRequestor: ' Requestor:',
  SFxAccountSettingsUserRequestColumnName: 'Name',
  SFxAccountSettingsUserRequestColumnRequestor: 'Requestor & Date',
  SFxAccountSettingsUserRequestColumnSolution: 'Solutions',
  SFxAccountSettingsUserRequestColumnStatus: 'Status',
  SFxAccountSettingsUserRequestStatusPending: 'Pending',
  SFxAccountSettingsUserRequestStatusApproved: 'Approved',
  SFxAccountSettingsUserRequestStatusDenied: 'Denied',
  SFxAccountSettingsUserRequestStatusSolved: 'Solved',
  SFxAccountSettingsUserRequestAlreadyProcessedApproved: 'Already approved by another administrator. Please refresh.',
  SFxAccountSettingsUserRequestAlreadyProcessedDenied: 'Already denied by another administrator. Please refresh.',
  SFxAccountSettingsUserRequestAlreadyProcessedSolved: 'Already created by another administrator. Please refresh.',
  SFxAccountSettingsUserRequestAlreadyProcessedThreshold: 'This organization could only have {0} users (current total user: {1}).',
  SFxAccountSettingsUserRequestDenyTitle: 'Deny Invitation Request',
  SFxAccountSettingsUserRequestDenyCancel: 'Cancel',
  SFxAccountSettingsUserRequestDenyOK: 'Yes, Deny',
  SFxAccountSettingsUserRequestDenyConfirm: 'Are you sure you want to deny the invitation request for:',
  SFxAccountSettingsUserRequestDenyConfirmDetail1: 'An email informing the requesting user that their invitation request has been denied will be sent.',
  SFxAccountSettingsUserRequestDenyConfirmDetail2: 'You may add a personal message to include below. This action cannot be undone.',
  SFxAccountSettingsUserRequestDenyLabel: 'Add message to requesting user (Optional)',
  SFxAccountSettingsApprovedBy: 'Approved by {0}',
  SFxAccountSettingsRejectBy: 'Denied by {0}',
  SFxTipsDetail: 'Detail',
  // Error message
  SFx401Error: '401 unauthorized error. Please contact the administrator.',
  SFx403Error: '403 forbidden error. Please contact the administrator.',
  SFx500Error: '500 server error. Please contact the administrator.',
  SFxUnknownError: 'Unexpected error occurred. Please try again later.',
  SFxAccountSettingsUserProfileFetchError: 'Unexpected error occurred while fetching user profile data. Please try again later.',
  SFxAccountSettingsUserProfileSaveError: 'Unexpected error occurred while saving user profile data. Please try again later.',
  SFxAccountSettingsUserRequestFetchError: 'Unexpected error occurred while fetching user requests data. Please try again later.'
};